var _defs, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagKr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 40,
    fill: "#cd2e3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 10 A40 40 0 0 1 50 90 A20 20 0 0 1 50 50 A20 20 0 0 0 50 10Z",
    fill: "#0047a0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49,
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKr);
export default __webpack_public_path__ + "static/media/flag-kr.580a1cfc13d97f1ef7b3a8c746a9aa9d.svg";
export { ForwardRef as ReactComponent };